import { Outlet } from "react-router-dom"

const Qcast = ()=>{
    return (
        <Outlet />
    )
}

export default Qcast;